import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getOrganizerDetails } from '../api/services/Rides';
import { OrganizerDetails } from '../types/organizer';

interface IUseOrganizerDetailsQuery {
  rideSlug: string;
  organizerSlug: string;
}

export const useOrganizerDetailsQuery = ({ rideSlug, organizerSlug }: IUseOrganizerDetailsQuery) => {
  return useApiGet<{ data: OrganizerDetails }>(
    ['organizerDetails', rideSlug, organizerSlug],
    () => getOrganizerDetails(rideSlug, organizerSlug),
    { enabled: true }
  );
};
